export default interface IMeasurementDetails {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    sampleDate: string;
    setId: string;
}

export class MeasurementDetails implements IMeasurementDetails {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    measurementId: string;
    orderId: string;
    sampleDate: string;
    setId: string;

    constructor(id: string, name: string, description: string, isEnabled: boolean, measurementId: string, orderId: string,
        sampleDate: string, setId: string) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.isEnabled = isEnabled;
        this.measurementId = measurementId;
        this.orderId = orderId;
        this.sampleDate = sampleDate;
        this.setId = setId;

    }
}

const defaultMeasurementDetails = new MeasurementDetails("", "", "", false, "", "", "", "");
export { defaultMeasurementDetails };
